import { render, staticRenderFns } from "./NotificationButton.vue?vue&type=template&id=b573f826&scoped=true&"
import script from "./NotificationButton.vue?vue&type=script&lang=js&"
export * from "./NotificationButton.vue?vue&type=script&lang=js&"
import style0 from "./NotificationButton.vue?vue&type=style&index=0&id=b573f826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b573f826",
  null
  
)

export default component.exports